import * as React from 'react';

export function FlexIcon({width = 9, height = 9, ...props}: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={width} height={height} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width={4} height={9} rx={2} fill="currentColor" />
            <rect x={5} width={4} height={9} rx={2} fill="currentColor" />
        </svg>
    );
}
